import { render, staticRenderFns } from "./TreasuryDispersionTables.vue?vue&type=template&id=59ad5288&scoped=true&"
import script from "./TreasuryDispersionTables.vue?vue&type=script&lang=js&"
export * from "./TreasuryDispersionTables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad5288",
  null
  
)

export default component.exports